<template>
  <div v-if="items.length" class="items">
    <v-container class="py-10 py-md-13 py-lg-16">
      <TitleWidget dark>
        {{ title }}
      </TitleWidget>

      <v-sheet
        class="
          white--text
          text-body-1 text-md-subtitle-1 text-center
          font-weight-medium
          mt-6
          mx-auto
        "
        color="transparent"
        max-width="650px"
      >
        {{ subtitle }}
      </v-sheet>

      <div class="mt-6 mt-md-10 grid-list">
        <ServiceCard
          v-for="(item, keyItems) in items"
          :key="keyItems"
          v-bind="item"
          dark
        />
      </div>
    </v-container>
  </div>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ServiceCard from "../cards/ServiceCard.vue";

const _config = {
  mod: "services",
};

const _data = {
  title: "Nossos Serviços",
  subtitle:
    "Oferecemos soluções abrangentes para suas necessidades de coleta e interpretação de dados.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  created() {
    this.$rest(_config.mod).get();
  },
  components: {
    TitleWidget,
    ServiceCard,
  },
};
</script>

<style lang="scss" scoped>
.items {
  background-image: url(../../assets/img/bg-services.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  .grid-list {
    display: grid;
    gap: 64px 30px;
    grid-template-columns: repeat(3, 1fr);

    @media screen and (max-width: 959.9px) {
      grid-template-columns: 1fr 1fr;
    }

    @media screen and (max-width: 599.9px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
